import { render } from "./PendingReturnHelpDialog.vue?vue&type=template&id=cac35df8&scoped=true"
import script from "./PendingReturnHelpDialog.vue?vue&type=script&lang=js"
export * from "./PendingReturnHelpDialog.vue?vue&type=script&lang=js"

import "./PendingReturnHelpDialog.vue?vue&type=style&index=0&id=cac35df8&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac35df8"]])

export default __exports__